import React, { useEffect, useState } from 'react';
import './_aboutBlock.scss';
import { Link } from 'react-scroll';
import { useHistory } from 'react-router-dom';

export default function AboutBlock ({ leftPadding, rightPadding, data, title }) {
  const [rangeValue, setRangeValue] = useState(0);
  const [offset, setOffset] = useState(null);
  const history = useHistory();

  const moveCube = (e) => {
    const { value } = e.target;
    setRangeValue(value);
  };

  useEffect(() => {
    if (+rangeValue === 100) {
      const whiteLayer = document.getElementById('whiteLayer');
      whiteLayer && whiteLayer.classList.add('show');
      setTimeout(() => {
        history.push('/about');
      }, 300);
    }
  }, [rangeValue, history]);

  useEffect(() => {
    const foot = document.getElementById('footer');
    const y = window.innerHeight - foot.clientHeight;
    setOffset(y);
  }, []);

  return (
    <section
      className={`aboutBlock
                         ${leftPadding ? 'leftPadding' : ''}
                         ${rightPadding ? 'rightPadding' : ''}`}
      id={'homeAboutSection'}
    >
      <div>
        <h3 className='text-lg-right'>{title}</h3>
        <p className='text-lg-right mb-4 mb-md-5'>
          <small>
            If you have any questions go to{' '}
            <Link
              spy
              smooth
              duration={1000}
              to='footer'
              offset={-offset}
            >
              Contact
            </Link>
            <br />
            We always love to hear from you.
          </small>
        </p>
        <p className='aboutUsText' dangerouslySetInnerHTML={{ __html: data }} />

        <div id='my-canvas'>
          <span>Explore our story</span>
          <div className='canvas-range'>
            <div className='endPointCircle' />
            <div className='canvas-rangeLine'>
              <span
                className='canvas-rangeBtn'
                style={{ left: `${rangeValue}%` }}
                id='canvas-rangeBtn'
              />
            </div>
            <input
              type='range'
              min='0'
              max='100'
              value={rangeValue}
              step='0.01'
              id='slider'
              onChange={moveCube}
            />
            <span />
          </div>
        </div>
      </div>
    </section>
  );
}
